export const getRedirect = () => {
  const redirect = sessionStorage.getItem("redirection");
  if (redirect) {
    return redirect;
  }
  return "/home-sso";
};

export const createBreadCrumbFromUrl = (url) => {
  const breadcrumb = [];
  const urlSplit = url.split("/");
  let key = 0;
  urlSplit.forEach((item, index) => {
    if (item) {
      breadcrumb.push({
        path: `${urlSplit.slice(0, index + 1).join("/")}`,
        name: item,
        key,
      });
      key += 1;
    }
  });
  return breadcrumb;
};

export const isEmail = (email) => {
  const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
  return re.test(String(email).toLowerCase());
};

export const convertDateStringToFrenchFormat = (dateString) => {
  const date = new Date(dateString);
  const options = {
    year: "numeric",
    month: "numeric",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
  };
  return date.toLocaleDateString("fr-FR", options);
};

export const isMacAddress = (mac) => {
  const re = /^([0-9A-F]{2}[:-]){5}([0-9A-F]{2})$/i;
  return re.test(mac);
};

export const isVlanAddress = (vlan) => {
  const re = /^(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)$/;
  return re.test(vlan);
};

export const getDefaultLanguage = () => {
  const supportedLangs = ["en", "fr"];
  const browserLang = navigator.language.split("-")[0];
  return supportedLangs.includes(browserLang) ? browserLang : "en";
};
